import BetMenuComponent from "slotworks/components/betbar/bet-menu-component";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import StateMachine from "slotworks/state-machine/state-machine";
import { AddWindowFocusChangeLsitener, RemoveWindowFocusChangeLsitener } from "slotworks/utils/browser-utils";
import Timer from "slotworks/utils/timer";
import Components from "../../components/components";
import FlexiToggle, { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";
import GeneralOptions from "slotworks/components/betbar/vo/general-options";
import autoplayModel from "slotworks/model/autoplay-model";

export default class SpinButtonBehaviour extends AbstractButtonBehaviour {

    private static QUICK_SPIN_HOLD: boolean = false;

    private autoButton: FlexiButton;
    private autoSpinTimer: number;
    private betTimer: number;

    private quickSpinToggle:FlexiToggle;

    private quickSpinTimer: number;

    constructor() {
        super();
    }

    public init() {
        // Spin button
        Layers.SmartButton.defaultScene().execute();
        this.button = Layers.SmartButton.getFlexiButton("spin");

        this.button.setVisible(true);
        this.button.setEnabled(true);

        this.button.on(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.addEventListener("keyup", this.onKeyUpListener);

        this.buttonAutoSpin = Layers.SmartButton.getFlexiButton("autospin");
        this.buttonBetMenu = Layers.SmartButton.getFlexiButton("betbtn");

        if (this.buttonAutoSpin) {
            if(autoplayModel.autoplayDisabled) {
                this.buttonAutoSpin.setVisible(false);
            } else
                this.buttonAutoSpin.on(ButtonEvent.POINTER_DOWN, this.showAutoplay);
        }
        if (this.buttonBetMenu) {
            this.buttonBetMenu.on(ButtonEvent.POINTER_DOWN, this.showBetMenu);
        }
        // Layouts with separate auto play button
        this.autoButton = Layers.SmartButton.getFlexiButton("auto_start");
        if (this.autoButton) {
            if(autoplayModel.autoplayDisabled) {
                this.autoButton.setVisible(false);
            } else
                this.autoButton.on(ButtonEvent.POINTER_DOWN, this.onAutoDownListener);
        }

        this.quickSpinToggle = Layers.SmartButton.getFlexiToggle("quickspin");
        if(this.quickSpinToggle) {
            if(SettingsModel.isQuickSpinDisabled()) {
                this.quickSpinToggle.setEnabled(false);
                this.quickSpinToggle.setVisible(false);
            } else {
                this.quickSpinToggle.setEnabled(true);
                this.quickSpinToggle.setVisible(true);
                this.quickSpinToggle.setValue(SettingsModel.getQuickSpin());
                this.quickSpinToggle.on(ToggleEvent.CHANGE, this.onQuickSpinChange);
                if(Components.betMenu) {
                    Components.betMenu.onSettingsOptionsCommitted.add(this.onOptionsChange);
                }
            }  
        }
    }
    public destroy() {
        this.button.off(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.removeEventListener("keyup", this.onKeyUpListener);
        if (this.buttonAutoSpin && !autoplayModel.autoplayDisabled) {
            this.buttonAutoSpin.off(ButtonEvent.POINTER_DOWN, this.showAutoplay);
        }
        if (this.buttonBetMenu) {
            this.buttonBetMenu.off(ButtonEvent.POINTER_DOWN, this.showBetMenu);
        }
        if (this.autoButton && !autoplayModel.autoplayDisabled) {
            this.autoButton.off(ButtonEvent.POINTER_DOWN, this.onAutoDownListener);
        }
        if(this.quickSpinToggle) {
            this.quickSpinToggle.off(ToggleEvent.CHANGE, this.onQuickSpinChange);
            if(Components.betMenu) {
                Components.betMenu.onSettingsOptionsCommitted.remove(this.onOptionsChange);
            }
            this.quickSpinToggle.setEnabled(false);
            this.quickSpinToggle.setVisible(false);
        }
        super.destroy();
    }
    private showAutoplay = () => {
        this.autoSpinTimer = Timer.setTimeout(() => {
            Components.betMenu.show(BetMenuComponent.AUTOPLAY);
        }, 170);

    }
    private showBetMenu = () => {
        this.betTimer = Timer.setTimeout(() => {
            Components.betMenu.show(BetMenuComponent.BET);
        }, 170);
    }
    private onKeyUpListener = (event: any) => {
        if (SettingsModel.getSpaceToSpin()) {
            if (event.keyCode === 32) {
                this.spin(true);
            }
        }
    }

    private onDownListener = () => {
        this.spin(false);
    }

    private spin = (spacePressed: boolean = false) => {
        StateMachine.skip();

        if (!spacePressed && SpinButtonBehaviour.QUICK_SPIN_HOLD) {
            // this.quickSpinTimer = Timer.setTimeout(() => {
            //     this.quickSpinTimer = Timer.setInterval(() => StateMachine.skip(), 500);
            // }, 1000);

            AddWindowFocusChangeLsitener(this.onRelease);
            window.addEventListener(ButtonEvent.POINTER_UP.getEventString(), this.onRelease, true);
        }
    }

    private onRelease = () => {
        Timer.clearTimeout(this.quickSpinTimer);
        Timer.clearInterval(this.quickSpinTimer);

        RemoveWindowFocusChangeLsitener(this.onRelease);
        window.removeEventListener(ButtonEvent.POINTER_UP.getEventString(), this.onRelease, true);
    }

    private onAutoDownListener = () => {
        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN_SELECT, true);
    }

    private onQuickSpinChange = () => {
        const quickSpin = this.quickSpinToggle.getValue();
        SettingsModel.setQuickSpin(quickSpin);
        const options = SettingsModel.generateGeneralOptions();
        Components.betMenu.setGeneralOptions(options);
    }

    private onOptionsChange = (newGeneralOptions: GeneralOptions) => {
        this.quickSpinToggle.setValue(newGeneralOptions.quickSpin);
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/smart-button/behaviours/spin-button-behaviour.ts